type SnapshotDetailsResponse = {
  data?: {
    snapshot?: {
      status?: string;
    };
  };
};

export const checkSnapshotStatus = (snapDetails: SnapshotDetailsResponse) => {
  const status = snapDetails?.data?.snapshot?.status ?? "completed";
  const isNotCompleted = status !== "completed";
  return { status, isNotCompleted };
};
